import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "panel"]

  connect() {
    // Handle escape key
    document.addEventListener('keydown', this.handleEscape.bind(this))
    
    // Handle resize
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleEscape.bind(this))
    window.removeEventListener('resize', this.handleResize.bind(this))
  }

  toggle() {
    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    // Show backdrop on mobile
    if (window.innerWidth < 1024) {
      this.backdropTarget.classList.remove('hidden')
      this.backdropTarget.classList.add('lg:hidden')
    }
    
    // Slide in panel
    this.panelTarget.classList.remove('-translate-x-full')
    this.panelTarget.classList.add('translate-x-0')
    
    // Prevent body scroll on mobile
    if (window.innerWidth < 1024) {
      document.body.style.overflow = 'hidden'
    }
  }

  close() {
    // Hide backdrop
    this.backdropTarget.classList.add('hidden')
    
    // Slide out panel on mobile
    if (window.innerWidth < 1024) {
      this.panelTarget.classList.add('-translate-x-full')
      this.panelTarget.classList.remove('translate-x-0')
    }
    
    // Restore body scroll
    document.body.style.overflow = ''
  }

  isOpen() {
    return !this.backdropTarget.classList.contains('hidden')
  }

  handleEscape(event) {
    if (event.key === 'Escape' && this.isOpen()) {
      this.close()
    }
  }

  handleResize() {
    // Auto-close on desktop
    if (window.innerWidth >= 1024 && this.isOpen()) {
      this.close()
    }
  }

  handleTouchMove(event) {
    // Prevent overscroll on mobile
    event.stopPropagation()
  }
}
